import React, { Fragment, useState } from 'react'
import { Container, Card, Grid, CardContent, Typography } from '@material-ui/core';
import Breadcumb from '../../../components/Breadcumb/Breadcumb';
import CKEditor from "react-ckeditor-component";
import { Faqs, Alerts } from '../../../helpers';
const BreadcrumbData = [
    {
        id: 1,
        page_title: "Dashboard",
        page_path: "/",
        icon: "tachometer",
    },
    {
        id: 2,
        page_title: "Banner",
        page_path: "/app/profile",
        icon: "",
    }
]
const CreateFaq = () => {
    const [ques, setQues] = useState('');
    const [ans, setAns] = useState('');

    const handleQuesChange = (e) => {
        setQues(e.target.value);
    }
    const handleChangeAns = (e) => {
        var newContent = e.editor.getData();
        setAns(newContent);
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            ques: ques,
            ans: ans
        }
        let resp = await Faqs.createFaq(data)
        if (resp) {
            if(resp.status){
                Alerts.alertMessage(resp.message, '', 'success')
                setTimeout(function(){
                    window.location.reload();
                 }, 3000);
              }else{
                Alerts.alertMessage(resp.message, '', 'danger')
              }
        }
    }
    return (
        <Fragment>
            <Breadcumb items={BreadcrumbData} />
            <div className="page-wrapper mt20">
                <Container >
                    <Card className="card">
                        <CardContent>
                            <Grid container spacing={3}>
                                <Grid item lg={6} sm={6}>
                                    <Typography variant="h5" gutterBottom>
                                        Create Faq
                                    </Typography>
                                    <form onSubmit={handleSubmit}>
                                        <div className='form-group'>
                                            <label>Question</label>
                                            <input type="text" className='form-control' value={ques} onChange={handleQuesChange} />
                                        </div>
                                        <div className='form-group'>
                                            <label>Answer</label>
                                            <CKEditor
                                                activeClass="p10"
                                                content={ans}
                                                events={{
                                                    "afterPaste": handleChangeAns,
                                                    "change": handleChangeAns
                                                }}
                                            />
                                        </div>
                                        <button type="submit" className='btn btn-primary'>Submit</button>
                                    </form>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Container>
            </div>
        </Fragment>
    )
}

export default CreateFaq